import { useApi } from '@backstage/core-plugin-api';
import { scmAuthApiRef } from '@backstage/integration-react';
import { useCallback, useMemo } from 'react';

export function useScmIdentity() {
  const scmAuthApi = useApi(scmAuthApiRef);

  const identityApi = useCallback(
    async (url: string) => {
      const credentialsResult = await scmAuthApi.getCredentials({
        additionalScope: {
          repoWrite: true,
        },
        url,
      });
      return credentialsResult.token;
    },
    [scmAuthApi],
  );
  return useMemo(() => ({ getToken: identityApi }), [identityApi]);
}
